export * from '@lazy-cjk/zh-convert-table/table_plus';
import m from '@lazy-cjk/zh-convert-table/table_plus';

export default m;
